import "../../../../css/modal/PasswordResetModal.css"
import { useState } from "react"
import { setInvalidMessage, moveModal } from "../../../../utils/Utils"
import proxy from "../../../../utils/Proxy";

let TeacherPasswordResetModal = (props) => {
    let [submitted, setSubmitted] = useState(false)

    let setPassword = () => {
        let dialogResult = window.confirm("저장 하시겠습니까?");
        if (!dialogResult) return;

        setSubmitted(true);

        let password1Element = document.getElementById("teacher-password-reset-input1");
        let password2Element = document.getElementById("teacher-password-reset-input2");

        //set invalid message
        setInvalidMessage(password1Element, "teacher-password-reset-invalid1", "8글자 이상 입력해주세요.");
        setInvalidMessage(password2Element, "teacher-password-reset-invalid2", "비밀번호가 일치하지않습니다.");

        // valid check
        if (!password1Element.validity.valid || !password2Element.validity.valid) {
            window.alert("다시 입력하세요.");
            return;
        }
        proxy.put("/adminapi/teachers/" + props.teacherid, { password: password1Element.value }).then(() => {
            window.alert("변경 되었습니다.");
            props.onCloseClick();
        }).catch(res => window.alert(res.response.data.message));
    }
    let passwordChange = (e) => {
        setInvalidMessage(e.target, "teacher-password-reset-invalid1", "4글자 이상 입력해주세요.")
        let passwordConfirm = document.getElementById("teacher-password-reset-input2")
        passwordConfirm.pattern = e.target.value;
        if (passwordConfirm.validity.valid)
            setInvalidMessage(passwordConfirm, "teacher-password-reset-invalid2", "비밀번호가 일치하지 않습니다.");
    }
    let passwordCheckChange = (e) => {
        setInvalidMessage(e.target, "teacher-password-reset-invalid2", "비밀번호가 일치하지않습니다.");
    }

    let cancelPasswordReset = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult)
            props.onCloseClick()
    }

    return (
        <div className="modal-container">
            <div className="modal" id="password-reset-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={(e) => moveModal(e, "password-reset-modal")}>
                        <p className="modal-title">
                            비밀번호 재설정
                        </p>
                        <div className="modal-close-button" onClick={cancelPasswordReset}></div>
                    </div>
                    <div className="modal-content" id="password-reset-modal-content">
                        <div className="modal-content-items-container">
                            <div className="modal-content-item modal-content-align-start">
                                <div className="modal-content-divider-2">
                                    <p className="modal-content-text">비밀번호</p>
                                </div>
                                <div className="modal-content-divider-2">
                                    <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                        id="teacher-password-reset-input1"
                                        type="password"
                                        onChange={passwordChange}
                                        onBlur={e => { setInvalidMessage(e.target, "teacher-password-reset-invalid1", "4글자 이상 입력해주세요.") }}
                                        pattern={".{4,}"} required></input>
                                    <p className="modal-input-invalid-message" id="teacher-password-reset-invalid1">

                                    </p>
                                </div>
                            </div>
                            <div className="modal-content-item modal-content-align-start">
                                <div className="modal-content-divider-2">
                                    <p className="modal-content-text">비밀번호 확인</p>
                                </div>
                                <div className="modal-content-divider-2">
                                    <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                        id="teacher-password-reset-input2"
                                        type="password"
                                        onChange={passwordCheckChange}
                                        onBlur={passwordCheckChange}
                                        pattern={""} required></input>
                                    <p className="modal-input-invalid-message" id="teacher-password-reset-invalid2"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" >
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={setPassword}>
                                <p>변경</p>
                            </div>
                            <div className="modal-button" onClick={cancelPasswordReset}>
                                <p>취소</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeacherPasswordResetModal;